export default __webpack_public_path__ + "static/FiraMono-Medium-7c34726e4d0ed965d45a991b7e90af73.woff2";